export enum WarehouseKindEnum {
	OwnCentral = 1,
	ThirdPartySp = 2,
	OwnEmployee = 3,
	ThirdPartySelfEmployed = 4,
	ThirdPartyEmployee = 5,
	TransportCompanyWarehouse = 6
}